<style scoped  lang="less">
  @import 'detailsMatchStats.less'; // 引入公共LESS文件
</style>
<template>
  <div>
    <div class="data-loading" style="padding:20vh 0 50vh 0;"  v-if="isloginShow">
          <van-loading vertical><span class="loadtext">{{ langConfig.txtLang[langConfig.curLang]['LOADING'] }}</span></van-loading>
    </div>
    <div class="statsLi" v-if="!isloginShow">
    
      <ul v-if="statsList&&statsList.length>0">
        <!-- 控球率 -->
        <li v-if="statsObj[14]">
          <p class="title">
            {{statsObj[14].eventName}}
            <span>{{statsObj[14].homeValue}}</span>
            <span>{{statsObj[14].awayValue}}</span>
          </p>
          <p class="schedule">
            <span><i :class="statsObj[14].homeValue > statsObj[14].awayValue? 'win' : ''" :style="`width:${statsObj[14].homeValue}`"></i></span>
            <b></b>
            <span><i :class="statsObj[14].awayValue > statsObj[14].homeValue? 'win' : ''" :style="`width:${statsObj[14].awayValue}`"></i></span>
          </p>
        </li>
        <template v-for="(item, index) in statsList">
          <li :key="index" v-if="(item.id*1)!==14">
            <template  v-if="[4,41,3].indexOf(item.id*1)==-1">
              <p class="title on" :class="(item.homeValue==1?'on':'in')" v-if="item.isSpecialMark">
                {{item.eventName}}
              </p>
              <p class="title" v-if="!item.isSpecialMark">
                {{item.eventName}}
                <span>{{item.homeValue}}</span>
                <span>{{item.awayValue}}</span>
              </p>
              <p class="schedule" v-if="!item.isSpecialMark">
                <span><i :class="item.homeValue*1 > item.awayValue*1? 'win' : ''" :style="`width:${getWidth(item.homeValue,item.awayValue,1)}`"></i></span>
                <b></b>
                <span><i :class="item.awayValue*1 > item.homeValue*1? 'win' : ''" :style="`width:${getWidth(item.homeValue,item.awayValue,2)}`"></i></span>
              </p>
            </template>
            <template v-if="(item.id*1)==3">
                <p class="title" v-if="statsObj[3]">
                  {{statsObj[3].eventName}}
                  <span>{{statsObj[3].homeValue}}</span>
                  <span>{{statsObj[3].awayValue}}</span>
                </p>
                <p class="schedule" v-if="statsObj[3]">
                  <span><i :class="statsObj[3].homeValue*1 > statsObj[3].awayValue*1? 'win' : ''" :style="`width:${getWidth(statsObj[3].homeValue,statsObj[3].awayValue,1)}`"></i></span>
                  <b></b>
                  <span><i :class="statsObj[3].awayValue*1 > statsObj[3].homeValue*1? 'win' : ''" :style="`width:${getWidth(statsObj[3].homeValue,statsObj[3].awayValue,2)}`"></i></span>
                </p>
                <div class="s_mark" v-if="statsObj[41]||statsObj[4]">
                  <div class="s_markTop" v-if="statsObj[41]">
                    <b :class="statsObj[41].homeValue > statsObj[41].awayValue? 'win' : ''">{{statsObj[41].homeValue}}</b>
                    <span> {{statsObj[41].eventName}}</span>
                    <b :class="statsObj[41].awayValue > statsObj[41].homeValue? 'win' : ''">{{statsObj[41].awayValue}}</b>
                  </div>
                  <div class="s_markFoot" v-if="statsObj[4]">
                    <div class="s_markTop">
                      <b :class="statsObj[4].homeValue > statsObj[4].awayValue? 'win' : ''">{{statsObj[4].homeValue}}</b>
                      <span>{{statsObj[4].eventName}}</span>
                      <b :class="statsObj[4].awayValue > statsObj[4].homeValue? 'win' : ''">{{statsObj[4].awayValue}}</b>
                    </div>
                  </div>
                </div>
            </template>
          </li>

        </template> 
    
        
      </ul>

      <div class="no-data" v-else>
        <img :src="require(`@/assets/images/icon-nodata.png`)" alt="" />
        <span>{{ langConfig.txtLang[langConfig.curLang]['NO_DATA'] }}</span>
      </div>
    </div>


    
  </div>
</template>

<script>
import { getMatchStats } from '@/api/api';
export default {
  components: {
      
  },
  data() {
    return {
      isReadTime:0,
      isloginShow:true,
      baseParam:{ 
          userToken: '',
      },
      statsList:[],
      statsObj:{},
    };
  },
  methods: { 
    aaa(){
      //console.log('ss',this.statsList)
      //console.log('ss1',this.statsObj)
    },
    logdingFlag(){
      if(typeof(window) != 'undefined' && this.isloginShow){
        return true;
      }
      return false;
    },
    getWidth(h,a,t){
      let h1=parseInt(h+''.replace(/\D/g, ''), 10);
      let a1=parseInt(a+''.replace(/\D/g, ''), 10);
      var ha=h1/(h1*1+a1*1);
      if(t==1){
        return ha*100+'%';
      }else{
        return (1-ha)*100+'%';
      }

    },
    //数据清洗
    dataCleaning(stats){
      let statsObj = {};
      var _this=this;
      stats.forEach((stats_i, index) => {
        //console.log('stats_i.id',stats_i.id);
        statsObj[stats_i.id] = {
          ...stats_i,
          ...{index:index}
        };
      });
      _this.statsObj=statsObj;
    }, 
    //数据读取
    async getMatchStatsData(){
        let obj={
          matchId:this.matchId,
        }
        var _this=this;
        let param = Object.assign(obj, this.baseParam);
        //console.log('getMatchStats_param',param);
        await getMatchStats(param).then((res) => {
          _this.isloginShow=false;
          //console.log('getMatchStats_res',res);
          let data=JSON.parse(JSON.stringify(res.data));
          //console.log('getMatchStats_data',data);
          let stats=(data.stats||[]);
          // let statsObj = {};
          // stats.forEach((stats_i, index) => {
          //console.log('stats_i.id',stats_i.id);
          //   statsObj[stats_i.id] = {
          //     ...stats_i,
          //     ...{index:index}
          //   };
          // });
          _this.dataCleaning(stats);
          _this.statsList=data.stats;
          // _this.statsObj=statsObj;
          //console.log('getMatchSta-stats',stats);
          //console.log('getMatchSta-statsObj',statsObj);
        }).catch((res) => {
          console.error(res)
        })
    },
    init(){
      if(!this.matchId){
        return;
      } 
      this.getMatchStatsData();
    }
    
  },
  created() {
    this.isReadTime=this.isRead;
    this.init();
    
  },
  watch: {
    isRead(val){
      if(val!=this.isReadTime){
        this.init();
        this.isReadTime=val;
        console.log('MatchStats-数据重置');
      }
    },
    socketStatsList(val){
      var list=val||[];
      if(list.length>0){
        this.statsList=[]; 
        this.statsList=list;
        this.dataCleaning(list);
      }
    },
  },
  mounted() {
    
  },
  beforeDestroy() {
   
  },
  props: {
    match: {
      type: Object,
      default:null
    }, 
    matchId: {
      type: Number,
      default:null
    },
    socketStatsList:{
      type:Array,
      default:() =>[],
    },
    isRead: {
      type: Number,
      default: 0,
    },
  },
};
</script>



// WEBPACK FOOTER //
// ./src/views/details/components/detailsMatchStats.vue